import React from 'react'
import { GET_EPASS_LOGIN_CALLBACK } from 'requests'
import { connect } from 'react-redux'
import { storeAndDispatchLoginResponse } from '../../Auth/AuthActions'
import { Body } from '../Shell/Shell'
import { Spinner } from '../Loaders/Loaders'
import { PaymentError } from '../Checkout/PaymentCallback'
import ls from 'local-storage'

const EpassCallback = ({ dispatch, history }) => {
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    GET_EPASS_LOGIN_CALLBACK(
      user => {
        storeAndDispatchLoginResponse(user, dispatch)
        const returnUrl = ls.get('EPASS_RETURN_URL') || '/'
        history.replace(returnUrl)
      },
      err => {
        console.error(err)
        setError(err)
      }
    )
  }, [])
  return (
    <Body className="login-redirector">
      {error ? (
        <div className="payment-callback">
          <PaymentError errorCode={error.code} children={error.message} />
        </div>
      ) : (
        <Spinner className="page-loader" />
      )}
    </Body>
  )
}
export default connect()(EpassCallback)



// WEBPACK FOOTER //
// ./src/components/Epass/EpassCallback.js